import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {DeviceService} from "../../device/device.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {DeviceGqlModel} from "../../device/device.gql-model";
import {FilteredList} from "../../helpers/filtered-list";
import {ProjectModel, projectModelFactory} from "../../project/project.model";
import {ProjectService} from "../../project/project.service";

@Component({
  templateUrl: "./additional-device-information.template.pug",
  providers: [DeviceService],
})
export class AdditionalDeviceInfoComponent extends WorkflowStep {
  devices: FilteredList<DeviceGqlModel> = new FilteredList<DeviceGqlModel>({
    searchKeys: ["deviceKey", "productNumber", "productDescription", "friendlyName", "bundleNumber", "type"],
    exactMatchSearchKeys: ["id"],
    formKeys: ["id", "type", "productNumber", "friendlyName", "bundleNumber", "alreadyUsedQuantity", "disabled"],
    booleanFilters: [{
      caption: "Hide disabled devices",
      check: (item: DeviceGqlModel, value: boolean) => (value ? !item.disabled : true),
      value: true,
    }],
  });

  error: Error;
  project: ProjectModel = projectModelFactory();

  @handleErrors()
  async loadData() {
    this.devices.items = await this.deviceService.listDevicesForProject(this.workflowTargetInfo.targetId);
    this.project = await this.getProject();
  }

  private async getProject(): Promise<ProjectModel> {
    return this.projectService.getProjectById(this.workflowTargetInfo.targetId).toPromise();
  }

  ready(workflowTargetInfo: WorkflowTargetInfoModel, extraData: any) {
    if (extraData.filter) {
      this.devices.setSearchText(extraData.filter);
    }

    this.loadData();
  }

  @handleErrors()
  async save(): Promise<boolean> {
    const devices = (this.devices.form.value || {}).items || [];

    this.devices.items = await this.deviceService.updateDevicesForProject(this.workflowTargetInfo.targetId, devices);

    return true;
  }

  checkDirty(): boolean {
    return this.devices.form.dirty;
  }

  autoSave(): Promise<boolean> {
    return this.save();
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public deviceService: DeviceService,
    private projectService: ProjectService,
  ) {
    super();
  }
}
